import { createFileRoute } from '@tanstack/react-router'
import { CandidateChat } from '@/features/candidate-chat/chat'

export const Route = createFileRoute(
  '/_authenticated/candidate-chat/$conversationId/'
)({
  component: CandidateChat,
})
